import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-700 mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin da plataforma não usa o sistema da clínica (agenda, pacientes, financeiro
  // etc.) — a única área dele é a de gestão de clínicas.
  if ((user as any)?.is_platform_admin && location.pathname !== '/plataforma/clinicas') {
    return <Navigate to="/plataforma/clinicas" replace />;
  }

  return children;
};
